import React from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { TabsContainer, TabsPanel } from '../../tabs/TabsContainer';

const log = new Logger('REPORT_GENERATION_OPTIONS', LOG_LEVELS.DEBUG);

class ReportGenerationOptions extends React.Component {

    constructor(props){
        super(props);
        this.handleAfter = this.handleAfter.bind(this);
        this.prevTabIndex = 1;
        this.selectedTabIndex = 1;
        this.selectedTabId = undefined;
    }

    handleAfter(selectedIndex, selectedPanel, selectedTabMenu) {
        log.debug('ReportGenerationOptions: handleAfter ' + selectedIndex);
        this.prevTabIndex = this.selectedTabIndex;
        this.selectedTabIndex = selectedIndex;
        this.selectedTabId = undefined;
        if ((this.props.optionList !== undefined) && (this.props.optionList !== null)) {
          if (this.props.optionList.length >= selectedIndex)
          {
            this.selectedTabId = this.props.optionList[selectedIndex-1].id;
          }
        }
          
        this.props.onAfterTabSelected(selectedIndex, selectedPanel, selectedTabMenu, this.prevTabIndex, this.selectedTabId);
    }

    render () {
        const reportGenerationTaskComponents = this.props.optionList.map((task) => {
            return (
                <TabsPanel key={task.id} label={task.title}>
                    {task.component}
                </TabsPanel>
            );
        });

        return (
            <TabsContainer
                onTabChange={this.handleAfter}>
                {reportGenerationTaskComponents}
            </TabsContainer>
        );
    }
}

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);  
    return {};
}


ReportGenerationOptions.defaultProps = {
    optionList: [],
    onAfterTabSelected: () => {}
};

export default connect(mapStateToProps)(ReportGenerationOptions);

